import type { AxiosInstance } from 'axios';
import { createCrudService, type CrudService } from '../core/crud';
import type { RestaurantOrderLine, RestaurantOrderLineCreate, RestaurantOrderLineFilter } from '../data/restaurantOrderLine';

export function createRestaurantOrderLineService(client: AxiosInstance) {
  return createCrudService<RestaurantOrderLine, RestaurantOrderLineCreate, RestaurantOrderLineFilter>(
    client,
    '/restaurant/RestaurantOrderLine',
    'id',
  );
}

export type RestaurantOrderLineService = CrudService<RestaurantOrderLine, RestaurantOrderLineCreate, RestaurantOrderLineFilter>;
